import { isOrderPaymentAbandoned } from "../utils/abandonedOrderPayments";

/** Matches mobile Order History payment badge resolution (first match wins). */
export type OrderPaymentBadgeTone = "paid" | "failed" | "pending";

export function resolveOrderPaymentBadgeTone(
  paymentStatus: string | null | undefined,
  isSynced?: boolean,
  orderId?: string | number | null
): OrderPaymentBadgeTone {
  if (isSynced === true) return "paid";

  const normalized = String(paymentStatus ?? "").toLowerCase();
  if (normalized.includes("paid") || normalized.includes("success")) {
    return "paid";
  }
  if (normalized.includes("fail") || normalized.includes("declin")) {
    return "failed";
  }

  if (isOrderPaymentAbandoned(orderId)) {
    return "failed";
  }

  return "pending";
}

export const ORDER_PAYMENT_BADGE_STYLES: Record<
  OrderPaymentBadgeTone,
  { background: string; color: string; border: string }
> = {
  paid: {
    background: "rgba(22,163,74,0.08)",
    color: "#16a34a",
    border: "1px solid rgba(22,163,74,0.2)",
  },
  failed: {
    background: "rgba(220,38,38,0.08)",
    color: "#dc2626",
    border: "1px solid rgba(220,38,38,0.2)",
  },
  pending: {
    background: "rgba(245,158,11,0.08)",
    color: "#d97706",
    border: "1px solid rgba(245,158,11,0.2)",
  },
};

export function getOrderPaymentBadgeLabelKey(
  tone: OrderPaymentBadgeTone
): "status.paid" | "status.failed" | "status.pending" {
  if (tone === "paid") return "status.paid";
  if (tone === "failed") return "status.failed";
  return "status.pending";
}
